// extracted by mini-css-extract-plugin
export var cmsContent = "post-content-module--cmsContent--LXP6z";
export var heading = "post-content-module--heading--03nd7";
export var intro = "post-content-module--intro--x6jMk";
export var lookImage = "post-content-module--look-image--IJZqj";
export var lookImageWrap = "post-content-module--look-image-wrap--ubcZs";
export var lookLegend = "post-content-module--look-legend--8wOi2";
export var lookLegendItem = "post-content-module--look-legend-item--DTupo";
export var lookLegendItemActive = "post-content-module--look-legend-item-active--Mc+VH";
export var lookLegendLabel = "post-content-module--look-legend-label--LLIaw";
export var lookLegendNumber = "post-content-module--look-legend-number--L+wR6";
export var lookMessage = "post-content-module--look-message--bBEqY";
export var lookMobileSheet = "post-content-module--look-mobile-sheet--wpxqr";
export var lookMobileSheetClose = "post-content-module--look-mobile-sheet-close--nYeIj";
export var lookMobileSheetDesc = "post-content-module--look-mobile-sheet-desc--HVww2";
export var lookMobileSheetHeader = "post-content-module--look-mobile-sheet-header--SN9bB";
export var lookMobileSheetLabel = "post-content-module--look-mobile-sheet-label--CU5Rl";
export var lookMobileSheetLink = "post-content-module--look-mobile-sheet-link--26boM";
export var lookMobileSheetNumber = "post-content-module--look-mobile-sheet-number--83dH7";
export var lookPoint = "post-content-module--look-point--Rm2ez";
export var lookPointActive = "post-content-module--look-point-active--COflX";
export var lookPointCard = "post-content-module--look-point-card--MkOWr";
export var lookPointCardDesc = "post-content-module--look-point-card-desc--qjDOz";
export var lookPointCardLabel = "post-content-module--look-point-card-label--Ez-K7";
export var lookPointCardLink = "post-content-module--look-point-card-link--QXuPJ";
export var lookPointNumber = "post-content-module--look-point-number--BaiyA";
export var lookPointOpen = "post-content-module--look-point-open--TsnQr";
export var lookSheetIn = "post-content-module--look-sheet-in--f9NAc";
export var lookWrapper = "post-content-module--look-wrapper--q5wH0";
export var sectionContent = "post-content-module--section-content--d2cdG";
export var tag = "post-content-module--tag--mVN44";
export var tagContent = "post-content-module--tagContent--PN42i";
export var tagsContent = "post-content-module--tagsContent--dUfwE";